import CustomTable from "./custom_table";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TableChartIcon from "@mui/icons-material/TableChart";
import METODO_PAGO from "../../../dataComponets/metodo_pago copy.json";
import FORMA_PAGO from "../../../dataComponets/forma_pago copy.json";
import STATE from "../../../dataComponets/state copy.json";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
export const inf_order_update = [
  {
    label: "N, Orden",
    accessor: "order_number",
    sm: 4,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "User",
    sectionTitle: "Usuario",
    change: false,
    required: true,
    maxLength: 100,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: ReceiptIcon,
  },
  {
    label: "Fecha de Entrega",
    accessor: "date_received_document",
    sm: 7,
    dfl: "",
    type: "date",
    data_select: [],
    name_select: "",
    section: "User",
    sectionTitle: "Usuario",
    change: true,
    required: true,
    maxLength: 100,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: ReceiptIcon,
  },
  {
    label: "Proveedor",
    accessor: "business_partner",
    sm: 13,
    dfl: "",
    type: "text",
    data_select: [],
    accessorSelect: "business_partner_options",
    name_select: "Proveedor",
    section: "User",
    sectionTitle: "Usuario",
    getOptionLabel: "business_partner",
    change: false,
    required: true,
    maxLength: 100,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: ReceiptIcon,
  },
  {
    label: "RFC Proveedor",
    accessor: "supplier_rfc",
    sm: 6,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "User",
    sectionTitle: "Usuario",
    change: false,
    required: true,
    maxLength: 100,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: ReceiptIcon,
  },
  {
    label: "Metodo de Pago",
    accessor: "payment_method",
    sm: 15,
    dfl: "PUE",
    type: "select",
    data_select: FORMA_PAGO,
    name_select: "Forma de Pago",
    section: "User",
    sectionTitle: "Facturación",
    change: true,
    maxLength: 1000,
    minLength: 0,
    required: true,
    visible: true,
    method: "ALL",
  },

  {
    label: "Forma de Pago",
    accessor: "form_of_payment_code",
    sm: 15,
    dfl: "01",
    type: "autocomplete",
    data_select: METODO_PAGO,
    name_select: "Método de Pago",
    section: "User",
    sectionTitle: "Facturación",
    change: true,
    maxLength: 1000,
    minLength: 0,
    required: true,
    visible: true,
    method: "ALL",
  },

  {
    label: "Nota",
    accessor: "note",
    sm: 30,
    dfl: "",
    type: "multitext",
    data_select: [],
    name_select: "",
    section: "User",
    sectionTitle: "Usuario",
    change: true,
    required: true,
    maxLength: 100,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: ReceiptIcon,
  },

  {
    label: "Calle",
    accessor: "street",
    sm: 20,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
    icon: FmdGoodIcon,
  },

  {
    label: "Número Exterior",
    accessor: "outdoor_number",
    sm: 5,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Número Interior",
    accessor: "inside_number",
    sm: 5,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Colonia",
    accessor: "neighborhood",
    sm: 15,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Código Postal",
    accessor: "zip_code",
    sm: 5,
    dfl: "",
    type: "int",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: true,
    maxLength: 5,
    minLength: 4,
    visible: true,
    method: "ALL",
  },

  {
    label: "Municipio",
    accessor: "town",
    sm: 10,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Estado",
    accessor: "state",
    sm: 10,
    dfl: "VERACRUZ DE IGNACIO DE LA LLAVE",
    type: "autocomplete",
    data_select: STATE,
    name_select: "Estado",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: true,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Localidad",
    accessor: "city",
    sm: 10,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "País",
    accessor: "country",
    sm: 10,
    dfl: "MÉXICO",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Referencia",
    accessor: "reference",
    sm: 20,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Tipo de Dirección",
    accessor: "address_type",
    sm: 5,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: false,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },

  {
    label: "Sucursal",
    accessor: "subsidiary",
    sm: 5,
    dfl: "",
    type: "text",
    data_select: [],
    name_select: "",
    section: "address",
    sectionTitle: "Dirección",
    change: false,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    method: "ALL",
  },
];

export const inf_order_update_concept = [
  {
    label: "Table",
    accessor: "details",
    sm: 30,
    dfl: "",
    type: "custom",
    data_select: [],
    name_select: "",
    section: "custom",
    sectionTitle: "Conceptos",
    change: true,
    required: false,
    maxLength: 1000,
    minLength: 0,
    visible: true,
    customComponent: CustomTable,
    method: "ALL",
    icon: TableChartIcon,
  },
];
